// ResidencyDisclosure — Phase 3c pre-sign disclosure line.
import React from "react";
import { getActiveRegion } from "../configs/regionConfig";

/**
 * @param {{ companyName?: string|null, regionDisplayName?: string|null }} props
 */
export default function ResidencyDisclosure({ companyName, regionDisplayName }) {
  const region =
    regionDisplayName ||
    getActiveRegion()?.displayName ||
    "United States";

  return (
    <span>
      Data storage region: <strong>{region}</strong>
    </span>
  );
}
